import { createFileRoute } from '@tanstack/react-router';
import TerminalContactDetailView from '../terminal/ManageTerminalContactsView/components/TerminalContactDetailView';
export const Route = createFileRoute('/terminals/locations/$terminalId_/contacts/$contactId')({
  component: TerminalContactDetailView,
});
